import {
  Box,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { CRM_CONNECTOR_CAPABILITIES } from '../../constants/crmConnector';
import type { CrmConnectorCapabilityField } from '../../constants/crmConnector';

interface CrmConnectorCapabilityListProps {
  values: Record<CrmConnectorCapabilityField, boolean>;
  onToggle: (field: CrmConnectorCapabilityField) => void;
  disabled?: boolean;
  disabledFields?: readonly CrmConnectorCapabilityField[];
}

export default function CrmConnectorCapabilityList({ values, onToggle, disabled, disabledFields }: CrmConnectorCapabilityListProps) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        Only the actions ticked here are ever called.
      </Typography>
      <List dense disablePadding sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
        {CRM_CONNECTOR_CAPABILITIES.map(({ field, title, description }, index) => (
          <ListItem key={field} disablePadding divider={index < CRM_CONNECTOR_CAPABILITIES.length - 1}>
            <ListItemButton onClick={() => onToggle(field)} disabled={disabled || disabledFields?.includes(field)} sx={{ alignItems: 'flex-start', py: 1 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.25 }}>
                <Checkbox
                  edge="start"
                  size="small"
                  checked={values[field]}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': `${field}-label` }}
                />
              </ListItemIcon>
              <ListItemText
                id={`${field}-label`}
                primary={title}
                secondary={description}
                primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                secondaryTypographyProps={{ variant: 'caption' }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
